import { useQuery } from '@tanstack/react-query';
import { reportBuilderApi } from '../api/reportBuilderApi';
import type { GenerationListFilter } from '../types/reportBuilder';

/**
 * GET /api/eraf/report-builder/generations — 생성 이력 목록 (REPORT_READ)
 * queryKey: ['report-builder', 'generations', 'list', filters]
 */
export function useGenerationHistory(filters: GenerationListFilter) {
  return useQuery({
    queryKey: ['report-builder', 'generations', 'list', filters],
    queryFn: () =>
      reportBuilderApi.generationList({
        definitionId: filters.definitionId,
        format: filters.format || undefined,
        status: filters.status || undefined,
        ownerScope: filters.ownerScope ?? 'mine',
        from: filters.from,
        to: filters.to,
        page: filters.page ?? 0,
        size: filters.size ?? 20,
        sort: filters.sort ?? 'generatedAt,desc',
      }),
    staleTime: 30_000,
  });
}
